import { useEffect } from 'react'
import { splitbee } from '../splitbee/web'
import { useZeus } from '../utils/useZeus'

// NOTE: This component exists because it uses Zeus
// but it should not be rendered outside of _app.js
export const InitSplitbee = () => {
  const { data } = useZeus({
    user: [
      {},
      {
        id: true,
        email: true,
      },
    ],
  })

  useEffect(() => {
    if (!data?.user?.email) return

    splitbee.user.set({ userId: data.user.email })
  }, [data])

  return null
}
